import React, { useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import Tabs from "@mui/material/Tabs";
import EventIcon from "@mui/icons-material/Event";
import moment from "moment";
import { Chip, Paper, Stack, Typography } from "@mui/material";
import * as constants from "../../Components/constants";
import Link from "next/link";
const BASE_URL = constants.BASE_URL;

const GroupCourse = ({ groupID }) => {
  const [data, setData] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  //Getting Course Category
  React.useEffect(() => {
    fetch(`${BASE_URL}/course/categories/`)
      .then((res) => res.json())
      .then((data) => {
        setCategories(data);
      });
  }, []);

  React.useEffect(() => {
    setLoading(true);
    fetch(`${BASE_URL}/course/${groupID}/all/?search=`)
      .then((res) => res.json())
      .then((data) => {
        setData(data);
        setLoading(false);
      });
  }, [groupID]);

  if (isLoading) return <p>Loading...</p>;
  if (!data) return <p>No profile data</p>;
  return (
    <>
      <Row className="p-2">
        <Col>
          <Tabs
            variant="scrollable"
            sx={{
              borderBottom: 2,
              borderTop: 2,
              borderColor: "divider",
              display: "flex",
              alignItems: "center",
            }}
          >
            {categories.map((course, id) => (
              <Chip
                className="mx-1"
                key={id}
                label={course.name}
                variant="outlined"
                size="small"
              />
            ))}
          </Tabs>
        </Col>
      </Row>

      {/*----- Course View Section----- */}
      <Row xs={1} sm={2} md={4} className="g-2 mb-3">
        {data.map((course, idx) => (
          <Col key={idx}>
            <Link href={`/course/${course.id}`}>
              <Paper
                elevation={0}
                style={{ cursor: "pointer" }}
                className="rounded-4"
              >
                <Card.Body>
                  <Card.Img
                    width={290}
                    height={170}
                    variant="top"
                    src={course.cover_pic}
                    alt={course.name}
                  />

                  <Card.Title
                    className="mx-2 fs-6 p-2 text-center"
                    style={{ height: "62px" }}
                  >
                    {course.name}
                  </Card.Title>

                  <Card.Text className="px-2 pt-2">
                    <Stack direction="row" alignItems="center" gap={1}>
                      <EventIcon />
                      <Typography variant="caption">
                        Enrollment End:{" "}
                        {moment(course.course_enroll_end_date).format(
                          "MMM Do YY"
                        )}
                      </Typography>
                    </Stack>

                    <Stack direction="row" alignItems="center" gap={1}>
                      <EventIcon color="secondary" />
                      <Typography variant="caption">
                        Course Start:{" "}
                        {moment(course.course_start_date).format("MMM Do YY")}
                      </Typography>
                    </Stack>
                  </Card.Text>

                  <div className="text-center">
                    <b style={{ color: "#28336F" }}>
                      {course.enrollment_fee} BDT
                    </b>
                  </div>
                </Card.Body>
              </Paper>
            </Link>
          </Col>
        ))}
      </Row>
      {data.length === 0 && (
        <div>
          <div className="d-flex justify-content-center align-items-end mt-5">
            <h5 className="text-danger">Not Available</h5>
          </div>
        </div>
      )}
    </>
  );
};

export default GroupCourse;
